"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ABtestProvider = exports.useABtest = exports.getExperiments = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const EXPERIMENT_URL_PROD = 'https://data.services.vente-privee.com';
const EXPERIMENT_URL_PREPROD = 'https://data.services.preprod.vente-privee.com';
const PATH = '/frontservices/api-distribution/v1/variations';
const getUrl = (env) => {
    switch (env) {
        case 'production':
        case 'prod':
            return EXPERIMENT_URL_PROD;
        case 'development':
        case 'preprod':
        case 'preproduction':
        case 'preprodaws':
            return EXPERIMENT_URL_PREPROD;
        default:
            return '';
    }
};
const defaultAbTest = { variation: { name: '' } };
const getAbTestingUrl = ({ memberId, siteId, env }) => {
    if (!memberId || !siteId)
        return '';
    const url = getUrl(env);
    if (!url)
        return '';
    return `${url}${PATH}/${memberId}?siteId=${siteId}`;
};
const trimExperiment = (exp) => {
    var _a;
    if ((_a = exp === null || exp === void 0 ? void 0 : exp.variation) === null || _a === void 0 ? void 0 : _a.name)
        return { variation: { name: exp.variation.name } };
    return defaultAbTest;
};
const filterExperiments = ({ ue_ab_messagecenter_web, postsales_tech_rosedeal_menu_display_web, postsales_tech_adr_web, postsales_tech_menu_revamp_web, postsales_tech_burger_menu_revamp_web, }) => {
    const experiments = {};
    if (ue_ab_messagecenter_web) {
        experiments.ue_ab_messagecenter_web = trimExperiment(ue_ab_messagecenter_web);
    }
    if (postsales_tech_rosedeal_menu_display_web) {
        experiments.postsales_tech_rosedeal_menu_display_web = trimExperiment(postsales_tech_rosedeal_menu_display_web);
    }
    if (postsales_tech_adr_web) {
        experiments.postsales_tech_adr_web = trimExperiment(postsales_tech_adr_web);
    }
    if (postsales_tech_menu_revamp_web) {
        experiments.postsales_tech_menu_revamp_web = trimExperiment(postsales_tech_menu_revamp_web);
    }
    if (postsales_tech_burger_menu_revamp_web) {
        experiments.postsales_tech_burger_menu_revamp_web = trimExperiment(postsales_tech_burger_menu_revamp_web);
    }
    return experiments;
};
const getExperiments = ({ memberId, siteId, env, logger }) => {
    const url = getAbTestingUrl({ memberId, siteId, env });
    if (!url)
        return Promise.resolve();
    return fetch(url)
        .then((res) => res.json())
        .then((data) => filterExperiments(data === null || data === void 0 ? void 0 : data.experiments))
        .catch((err) => {
        err.name = `@narf/abtest ${err.name}`;
        if (typeof window === 'undefined') {
            logger.captureException(err);
            return;
        }
        throw err;
    });
};
exports.getExperiments = getExperiments;
const ABtestContext = (0, react_1.createContext)(null);
const useABtest = () => (0, react_1.useContext)(ABtestContext);
exports.useABtest = useABtest;
const ABtestProvider = ({ experiments: experimentsSSR, memberId, siteId, env, logger, children }) => {
    const [experiments, setExperiments] = (0, react_1.useState)(experimentsSSR);
    (0, react_1.useEffect)(() => {
        if (!experiments && memberId) {
            (0, exports.getExperiments)({ memberId, siteId, env, logger }).then((res) => {
                if (res) {
                    setExperiments(res);
                }
            });
        }
    }, [memberId]);
    return (0, jsx_runtime_1.jsx)(ABtestContext.Provider, { value: experiments, children: children });
};
exports.ABtestProvider = ABtestProvider;
exports.ABtestProvider.defaultProps = {
    experiments: undefined,
    logger: {
        captureException: console.error,
        captureMessage: console.warn,
    },
    env: undefined,
};
exports.default = exports.ABtestProvider;
